<template>
    <div>
        <!-- Tabla -->
        <b-row class="mt-2">
            <b-col class="table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th rowspan="2">Componente</th>
                        <th rowspan="2"
                            class="text-center"
                        >
                            Porcentaje
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                           CSEO PECES
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                            CSEO CRUSTÁCEOS
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                            CSEO ALGAS
                        </th>
                        <th rowspan="2"
                            style="width: 50px;"
                            v-if="!only_view"
                        >
                        </th>
                    </tr>
                    <tr>
                        <th class="th-check"></th>
                        <th class="text-center"
                        >
                            mg/l
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                        <th class="th-check"></th>
                        <th class="text-center"
                        >
                            mg/l
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                        <th class="th-check"></th>
                        <th class="text-center"
                        >
                            mg/l
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="c in grouped_components.filter(comp => !comp.omit_in_composition)"
                        v-if="(c.name + c.cas_number).trim().toLowerCase().includes(name.trim().toLowerCase())"
                    >
                        <td>
                            <b-badge variant="secondary"
                                     size="sm"
                                     class="mr-1"
                                     style="width: 90px"
                            >
                                <span v-if="c.cas_number">
                                    {{ c.cas_number }}
                                </span>
                            </b-badge>
                            {{ c.name }}
                        </td>
                        <td class="text-center">
                            {{
                                Math.round(c.final_percentage * 10000) / 10000
                            }}%
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                     presenta toxicidad al medio ambiente a largo plazo
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_cseo_fish"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                 !!c.toxicity.cseo_fish ? c.toxicity.cseo_fish : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.cseo_fish">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.cseo_fish) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                     presenta toxicidad al medio ambiente a largo plazo
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_cseo_crustaceans"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                !!c.toxicity.cseo_crustaceans ? c.toxicity.cseo_crustaceans : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.cseo_crustaceans">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.cseo_crustaceans) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                     presenta toxicidad al medio ambiente a largo plazo
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_cseo_algae"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                !!c.toxicity.cseo_algae ? c.toxicity.cseo_algae : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.cseo_algae">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.cseo_algae) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td v-if="!only_view">
                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Editar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-primary"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="openModal(c.component)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-button>
                            </el-tooltip>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>

        <modal @update="_getClassification"/>
    </div>
</template>

<script>
import modal from './modal';
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'index',
    props: {
        name: {
            required: true,
            default: ''
        }
    },
    components: {
        modal
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'only_view',
            'totals',
            'classification',
            'grouped_components',
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getGroupedComponents',
            'getClassification',
            'downloadClassificationAcuteToxicity',
            'updateToxicitiesComponents',
            'downloadClassificationShortTermAquaticEnvironment'
        ]),
        ...mapMutations('calculator', [
            'setModalToxicityShow',
            'setComponent'
        ]),
        async _getClassification() {
            this.$emit('getClassification', 1);
        },
        openModal(component) {
            this.setComponent(JSON.parse(JSON.stringify(component)));
            this.setModalToxicityShow(true);
        },
        async _updateComponentProduct(component) {
            await this.updateToxicitiesComponents({components: [component]});
            await this._getClassification();
        }
    }
};
</script>
